export default __webpack_public_path__ + "static/media/production.1f832093.gif";